<script lang="ts" setup>
import LinkButton from "@/components/buttons/LinkButton.vue";
import { useI18n } from "vue-i18n";
import { DispatcherPermissionValue } from "@/api/dto/dispatcher.dto";
import type { RouteLocationRaw } from "vue-router";
import PermissionTooltip from "@/components/tooltips/PermissionTooltip.vue";

const { t } = useI18n();

defineProps<{
  to: RouteLocationRaw;
}>();
</script>

<template>
  <permission-tooltip :permission="DispatcherPermissionValue.EditOrCreateCompany">
    <template #activator="{ disabled }">
      <link-button :disabled="disabled" :to="to" color="success">
        {{ t("general.create-new") }}
      </link-button>
    </template>

    {{ t("permission.create-company") }}
  </permission-tooltip>
</template>
